var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.mobile
    ? _c(
        "div",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.close,
              expression: "close",
            },
          ],
          staticClass: "taxonomy",
        },
        [
          _c(
            "div",
            { staticClass: "taxonomy__title", on: { click: _vm.toggle } },
            [
              _vm._v("\n    Välj " + _vm._s(_vm.taxonomy.label) + "\n    "),
              _c("span", {
                staticClass: "taxonomy__arrow",
                class: _vm.opened
                  ? "taxonomy__arrow-opened"
                  : "taxonomy__arrow-closed",
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.opened,
                  expression: "opened",
                },
              ],
              staticClass: "taxonomy__list",
            },
            _vm._l(_vm.taxonomy.terms, function (term) {
              return _c(
                "li",
                {
                  key: term.term_id,
                  staticClass: "taxonomy__item",
                  class: {
                    "taxonomy__item-selected": _vm.isTaxonomySelected(
                      term.term_id
                    ),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.toggleTaxonomy(term.term_id)
                    },
                  },
                },
                [_vm._v("\n      " + _vm._s(term.name) + "\n    ")]
              )
            }),
            0
          ),
        ]
      )
    : _c("div", { staticClass: "mobile-filter__attribute" }, [
        _c("p", { staticClass: "mobile-filter__attribute-title" }, [
          _vm._v("Välj " + _vm._s(_vm.taxonomy.label)),
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "mobile-filter__attribute-list" },
          _vm._l(_vm.taxonomy.terms, function (term) {
            return _c(
              "li",
              {
                key: term.term_id,
                staticClass: "taxonomy__item",
                class: {
                  "taxonomy__item-selected": _vm.isTaxonomySelected(
                    term.term_id
                  ),
                },
                on: {
                  click: function ($event) {
                    return _vm.toggleTaxonomy(term.term_id)
                  },
                },
              },
              [_vm._v("\n      " + _vm._s(term.name) + "\n    ")]
            )
          }),
          0
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Taxonomy.vue